// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2fbf9dd2" + "." + "2aeef12d999e744d" + ".js";
};